module.exports = __webpack_public_path__ + "static/media/trenazer-interaktywny-tuo.93d51ff3.jpeg";